import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';
import Spinner from '../components/Spinner';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { user, login } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Already signed in → straight to the portal
  useEffect(() => {
    if (user) navigate('/portal');
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Basic validation
    if (!email || !password) {
      setError('Please enter both email and password');
      setLoading(false);
      return;
    }

    try {
      await login(email, password);
      navigate('/portal');
    } catch (err) {
      setError('Invalid email or password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <section id="wrapper">
        <div className="inner" style={{ paddingTop: "40px" }}>
          <h2 className="major" style={{ textAlign: "center" }}>Login to Range Drills</h2>
          
          <div className="content" style={{ 
            maxWidth: "800px", 
            margin: "0 auto", 
            padding: "30px", 
            backgroundColor: "rgba(27, 31, 34, 0.85)",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            marginTop: "20px",
            marginBottom: "40px"
          }}>
            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: "20px" }}>
                  <label 
                    htmlFor="email" 
                    style={{ 
                      display: "block", 
                      marginBottom: "8px",
                      color: "#fff",
                      fontWeight: "500"
                    }}
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "12px",
                      borderRadius: "6px",
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      color: "#fff",
                      fontSize: "1em",
                      outline: "none"
                    }}
                    placeholder="Enter your email"
                  />
                </div>

                <div style={{ marginBottom: "20px" }}>
                  <label 
                    htmlFor="password" 
                    style={{ 
                      display: "block", 
                      marginBottom: "8px",
                      color: "#fff",
                      fontWeight: "500"
                    }}
                  >
                    Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "12px",
                      borderRadius: "6px",
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      color: "#fff",
                      fontSize: "1em",
                      outline: "none"
                    }}
                    placeholder="Enter your password"
                  />
                </div>

                {error && (
                  <div style={{
                    padding: "10px",
                    marginBottom: "10px",
                    backgroundColor: "rgba(255, 87, 34, 0.2)",
                    border: "1px solid #FF5722",
                    borderRadius: "6px",
                    color: "#FF5722",
                    fontSize: "0.9em"
                  }}>
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    width: "100%",
                    padding: "15px",
                    borderRadius: "6px",
                    border: "none",
                    backgroundColor: loading ? "#999" : "#FF5722",
                    color: "#fff",
                    fontSize: "1.1em",
                    fontWeight: "bold",
                    cursor: loading ? "not-allowed" : "pointer",
                    transition: "background-color 0.3s ease",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center"
                  }}
                  onMouseEnter={(e) => {
                    if (!loading) {
                      e.target.style.backgroundColor = "#e64a19";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!loading) {
                      e.target.style.backgroundColor = "#FF5722";
                    }
                  }}
                >
                  {loading ? (<><Spinner size={16} style={{ marginRight: 8 }} />Logging in…</>) : 'Login'}
                </button>
              </form>

              <p style={{
                marginTop: "15px",
                textAlign: "center",
                fontSize: "0.9em"
              }}>
                <Link to="/forgot-password" style={{ color: "#FF5722", textDecoration: "none" }}>
                  Forgot your password?
                </Link>
              </p>

              <p style={{
                marginTop: "20px",
                textAlign: "center",
                fontSize: "0.9em",
                opacity: "0.8",
                color: "#fff"
              }}>
                Don't have an account? <Link
                  to="/register"
                  style={{ color: "#FF5722", textDecoration: "none" }}
                >
                  Register
                </Link>
              </p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Login;

